import { render, staticRenderFns } from "./orderSearch.vue?vue&type=template&id=513b8680&scoped=true&"
import script from "./orderSearch.vue?vue&type=script&lang=js&"
export * from "./orderSearch.vue?vue&type=script&lang=js&"
import style0 from "./orderSearch.vue?vue&type=style&index=0&id=513b8680&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513b8680",
  null
  
)

export default component.exports